var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandle1(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 79,
    viewBox: "0 0 85 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 79,
    transform: "translate(0.5)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_42684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6691 0C38.2214 0 24.8403 13.3445 24.8403 29.7472C24.8403 46.15 38.2214 59.4945 54.6691 59.4945C71.1168 59.4945 84.4979 46.15 84.4979 29.7472C84.4977 13.3445 71.1166 0 54.6691 0ZM54.6691 54.8622C40.7757 54.8622 29.4727 43.5957 29.4727 29.7472C29.4727 15.8988 40.7757 4.63233 54.6691 4.63233C68.5625 4.63233 79.8656 15.8989 79.8656 29.7472C79.8656 43.5956 68.5624 54.8622 54.6691 54.8622Z",
    fill: "#FE4747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9849 14.7567H52.3525V32.0634H69.6969V27.4311H56.9849V14.7567Z",
    fill: "#FE4747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72168 55.9745L20.1089 43.6223L23.3794 46.902L10.9921 59.2542L7.72168 55.9745Z",
    fill: "#FE4747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50049 40.6714L16.9041 29.3L20.1745 32.5797L8.77091 43.951L5.50049 40.6714Z",
    fill: "#FE4747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6401 75.7108L52.0438 64.3394L55.3142 67.6191L43.9106 78.9905L40.6401 75.7108Z",
    fill: "#FE4747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0366 70.1881L25.5132 55.7525L28.7836 59.0322L14.307 73.4678L11.0366 70.1881Z",
    fill: "#FE4747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2915 73.4946L37.6788 61.1423L40.9492 64.422L28.5619 76.7743L25.2915 73.4946Z",
    fill: "#FE4747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1230_42684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 79,
    fill: "white",
    transform: "translate(5.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandle1);
export default __webpack_public_path__ + "static/media/handle1.d21ec6e6bc3c0b2e0e2427eda52723f0.svg";
export { ForwardRef as ReactComponent };